// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import { createContext, useContext, type ReactNode } from 'react';

import { useCaseData, type CaseStore } from './useCaseData';

const CaseDataContext = createContext<CaseStore | null>(null);

/**
 * Mounts the one case store (`useCaseData`) for the Bygning shell. The shell
 * hands each mode `data` and `actions` as props; components deeper down that
 * need them read `useCaseStore()` instead of threading props.
 */
export function CaseDataProvider({ notify, children }: { notify: (message: string) => void; children: ReactNode }) {
  const store = useCaseData({ notify });
  return <CaseDataContext.Provider value={store}>{children}</CaseDataContext.Provider>;
}

export function useCaseStore(): CaseStore {
  const store = useContext(CaseDataContext);
  if (!store) throw new Error('useCaseStore must be used inside <CaseDataProvider>');
  return store;
}
